import { field_dark_theme } from 'framework/field/constants';
import { ModalTheme } from 'framework/modal/types';
import { colors } from 'framework/theme/constants/colors';
import { font_theme } from 'framework/theme/constants/font';

export const modal_theme: Pick<ModalTheme, 'general'> = {
  general: {
    font_family: font_theme.general.font_family,
    font_size: font_theme.general.font_size_normal,
    backdrop: 'rgba(0, 0, 0, 0.5)',
    border_radius: '8px',
    padding: '20px',
    margin: '50px auto',
  },
};

export const modal_dark_theme: ModalTheme = {
  general: modal_theme.general,
  background: { normal: colors.dark[12] },
  border: { normal: field_dark_theme.border.normal },
};
